import { ReactNode } from "react";

export function highlightMatchingText(text: string | undefined, query: string): ReactNode {
  if (!text) return text ?? "";

  const trimmedQuery = query.trim();
  if (!trimmedQuery) return text;

  const lowerText = text.toLocaleLowerCase();
  const lowerQuery = trimmedQuery.toLocaleLowerCase();
  const nodes: ReactNode[] = [];
  let startIndex = 0;
  let matchIndex = lowerText.indexOf(lowerQuery, startIndex);
  let matchCount = 0;

  while (matchIndex !== -1) {
    if (matchIndex > startIndex) {
      nodes.push(text.slice(startIndex, matchIndex));
    }

    nodes.push(
      <mark key={`${matchIndex}-${matchCount}`} className="recent-updates-widget__match">
        {text.slice(matchIndex, matchIndex + trimmedQuery.length)}
      </mark>,
    );

    startIndex = matchIndex + trimmedQuery.length;
    matchIndex = lowerText.indexOf(lowerQuery, startIndex);
    matchCount += 1;
  }

  if (nodes.length === 0) return text;
  if (startIndex < text.length) nodes.push(text.slice(startIndex));

  return <>{nodes}</>;
}
